import type { Approver } from "./Approver.type";
import type { Branch } from "./Branch.type";
import type { CostCenter } from "./CostCenter.type";
import { CustomerEmployeesGroup } from "./CustomerEmployeesGroup.type";
import { Phase } from "./Phase.type";
import { Project } from "./Project.type";

export type ApprovalType = "sequential" | "single";

export type Level = {
  approvers: Approver[];
};

export enum ModelTypeEnum {
  TRAVEL = "travel",
  ADVANCE = "advance",
  BROKEN_POLICY = "broken_policy",
  EXPENSE_REPORT = "expense_report",
}

export enum ApprovalTypeEnum {
  COST_CENTER = "cost_center",
  PHASE = "phase",
  PROJECT = "project",
  GROUP = "customer_employee_group",
}

export const APPROVAL_TYPE_TEXT = {
  [ApprovalTypeEnum.COST_CENTER]: "centro de custo",
  [ApprovalTypeEnum.PHASE]: "fase",
  [ApprovalTypeEnum.PROJECT]: "projeto",
  [ApprovalTypeEnum.GROUP]: "grupo",
};

export const MODEL_TYPE_TEXT = {
  [ModelTypeEnum.TRAVEL]: "viagem",
  [ModelTypeEnum.ADVANCE]: "adiantamento",
  [ModelTypeEnum.EXPENSE_REPORT]: "relatório de despesa",
};

export type ApprovalModel = {
  uuid: string;
  name: string;
  approvalType?: ApprovalTypeEnum;
  modelType?: ModelTypeEnum;
  isActive: boolean;
  customerEmployeeId?: string;
  agencyEmployeeId?: string;
  branch?: Branch;
  costCenters?: CostCenter[];
  groupApprovers?: CustomerEmployeesGroup[];
  projects?: Project[];
  groups?: CustomerEmployeesGroup[];
  phases?: Phase[];
  isAllBranches?: boolean;
  applyExpense?: boolean;
  approvers?: Approver[];
  outPolicyApprovalModel?: ShortApprovalModel;
  approverExpense?: {
    uuid?: string;
    name?: string;
  };
};

export type ShortApprovalModel = Pick<
  ApprovalModel,
  "uuid" | "name" | "isActive" | "approvalType" | "modelType" | "approvers"
>;
